/**
 * Authentication Client Store
 * Manages access and refresh tokens using browser cookies
 */

import { getCookie, setCookie, deleteCookie } from "../utils/cookies.ts";

export default class AuthClientStore {
  private static readonly ACCESS_TOKEN_KEY = "accessToken";
  private static readonly REFRESH_TOKEN_KEY = "refreshToken";

  /**
   * Get the current access token
   */
  static getAccessToken(): string | null {
    return getCookie(this.ACCESS_TOKEN_KEY);
  }

  /**
   * Set the access token
   */
  static setAccessToken(token: string): void {
    setCookie(this.ACCESS_TOKEN_KEY, token);
  }

  /**
   * Get the current refresh token
   */
  static getRefreshToken(): string | null {
    return getCookie(this.REFRESH_TOKEN_KEY);
  }

  /**
   * Set the refresh token
   */
  static setRefreshToken(token: string): void {
    setCookie(this.REFRESH_TOKEN_KEY, token);
  }

  /**
   * Clear all authentication tokens
   */
  static clearTokens(): void {
    deleteCookie(this.ACCESS_TOKEN_KEY);
    deleteCookie(this.REFRESH_TOKEN_KEY);
  }

  /**
   * Check if user is authenticated (has access token)
   */
  static isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }
}
